import {withFormik} from 'formik';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Mutation} from 'react-apollo';
import {Col, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {PulseLoader} from 'react-spinners';
import {checkErrorType} from '../../utils';
import {validateEmail} from '../../utils';
import Error from '../../common/components/Error/Error';
import LoginButton from '../../common/components/LoginButton';
import {LoginBackButton} from '../../common/components/StyledComp';
import Tooltip from '../../common/components/Tooltip';
import {ERROR_TYPE_BAD_REQUEST, ERROR_TYPE_INACTIVE_ACCOUNT} from '../../common/constants';
import {Alert} from '../../common/look';
import {GRAPHQL_MUTATION_FORGOT_ACCOUNT_PASSWORD} from '../../common/queries/users';
import {AttributeDiv} from './LoginForm';

const ForgotPasswordForm = ({t}) => {

  const [email, setEmail] = useState('');
  const [resetError, setError] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  return (
    <Mutation mutation={GRAPHQL_MUTATION_FORGOT_ACCOUNT_PASSWORD} variables={{email}}>
      {(sendMail, {loading, error}) => {
        if (error) {
          if (checkErrorType(error, ERROR_TYPE_BAD_REQUEST)) {
            setError(t('reg.unknownEmail'));
          } else if (checkErrorType(error, ERROR_TYPE_INACTIVE_ACCOUNT)) {
            setError(t('reg.disabledAccount'));
          } else {
            setError(t('reg.unknownError'));
          }
        }
        return (
          <React.Fragment>
            <Row>
              <Col xs={{span: 10, offset: 1}} lg={{span: 6, offset: 3}} xl={{span: 4, offset: 4}} className="inputs-block">
                <Error error={resetError} />
                {submitted && !error && !loading && email !== '' && validateEmail(email) && <Alert color="success">{t('forgotPass.form.submitMsg')}</Alert>}
                <div className="login-title">{t('resetPass.form.title')}</div>
                <Row>
                  <Col xs={12} lg={{span: 10, offset: 1}}>
                    <label className="mandatory-label">
                      <AttributeDiv className="label-name">{`${t('login.form.field.email')} : `}</AttributeDiv>
                      <input
                        className="login-input"
                        type="text"
                        name="email"
                        value={email}
                        onChange={e => {
                          setEmail(e.target.value);
                          setSubmitted(false);
                        }}
                        placeholder={t('login.form.field.emailPlaceHolder')}
                      />
                    </label>
                    <Tooltip show={(submitted && email === '') || (submitted && !validateEmail(email))} color={'red'}>
                      {t('reg.invalidEmail')}
                    </Tooltip>
                  </Col>
                  <Col xs={12} lg={{span: 10, offset: 1}}>
                    <div className="text-center">
                      {loading ? (
                        <div className="centered-loader">
                          <PulseLoader />
                        </div>
                      ) : (
                        <React.Fragment>
                          <Row className="">
                            <Col sm={6} xs={12}>
                              <LoginBackButton>
                                <Link to="/login" className="button-link">
                                  {t('reg.back')}
                                </Link>
                              </LoginBackButton>
                            </Col>
                            <Col sm={6} xs={12}>
                              <LoginButton onClick={() => {
                                if (email !== '' && validateEmail(email)) {
                                  sendMail();
                                }
                                setSubmitted(true);
                              }}>
                                {t('forgotPass.form.btnSubmit')}
                              </LoginButton>
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </React.Fragment>
        );
      }}

    </Mutation>
  );
};

ForgotPasswordForm.propTypes = {
  handleSubmit: PropTypes.func,
  onSubmit: PropTypes.func,
  errors: PropTypes.object,
  sent: PropTypes.bool,
  values: PropTypes.object,
  t: PropTypes.func,
};

const ForgotPasswordFormWithFormik = withFormik({
  enableReinitialize: true,
  mapPropsToValues: () => ({email: ''}),
  async handleSubmit(
    values,
    {
      setErrors,
      resetForm,
      props: {onSubmit},
    },
  ) {
    await onSubmit(values)
      .then(() => resetForm())
      .catch(e => {
        throw e;
      });
  },
  displayName: 'ForgotPasswordForm', // helps with React DevTools
});

export default withTranslation('login')(ForgotPasswordFormWithFormik(ForgotPasswordForm));
